export default {
  header: {
    title: "استخرهای مشارکت و استیکینگ",
    description:
      "استیکینگ ارز دیجیتال، فرصتی استثنایی در دنیای ارزهای دیجیتال است که به شما اجازه می‌دهد با قفل کردن دارایی‌های خود در شبکه‌های بلاکچین، هم به امنیت و پایداری این شبکه‌ها کمک کنید و هم پاداش‌های مستمر دریافت نمایید. این روش، راهکاری ساده و کم‌ریسک برای کسب درآمد غیرفعال است که نیازی به تجربه پیچیده در ترید یا مدیریت فعال ندارد.",
    link_1: "مولتی استیکینگ",
    link_2: "سوالات متداول",
    link_3: "زمان بندی پروسه استیکنیگ",
    quick_access: "دسترسی سریع",
    crypto_pool_investment_fund: "صندوق مشارکت استخر رمزارزی",
    pool_investment_staking: "استخرهای مشارکت و استیکینگ",
    uranus: "صندوق اورانوس",
    dialog_des:
      "محاسبه پاداش از ساعت 15 روز شروع طرح آغاز می شود و از یک روز بعد از شروع در پنل کاربری قابل مشاهده است. محاسبه پاداش طی دوره عضویت و دوره آزادسازی انجام نخواهد شد. واریز پاداش دوره حداکثر تا یک روز بعد از اتمام طرح به کیف پول کاربری واریز خواهد شد. در صورت لغو پیش از اتمام زمان طرح، درخواست‌های لغو تا پیش از ساعت 15 در همان روز و غیر از آن از ساعت 15 روز بعد در فرآیند آزادسازی قرار می‌گیرند.",
    dialog_action: "متوجه شدم"
  },
  stakingPlans: {
    tab_1: "طرح های مشارکت",
    tab_2: "طرح های من",
    No_Plans_Found: "طرحی پیدا نشد",
    No_Plans_For_This_Condition: "در حال حاضر طرحی برای این حالت وجود ندارد",
    View_More: "مشاهده بیشتر",
    filters: {
      ALL: "نمایش همه",
      VIP: "طرح ویژه",
      MAX_PROFIT: "بیشترین پاداش",
      MIN_PROFIT: "کمترین پاداش",
      MAX_TIME: "بیشترین زمان",
      MIN_TIME: "کمترین زمان",
      FIXED: "شرایط ثابت",
      FLEXIBLE: "شرایط متغیر",
      COMPARE_ASSET: "تطابق با دارایی‌ ها",
      ACTIVE: "فعال",
      TERMINATED: "پایان یافته",
      CANCELED: "لغو شده",
      searchPlaceHolder: "جستجو رمزارز"
    },
    plans: {
      flexibleConditions: "شرایط انعطاف پذیر",
      details: {
        planDuration: "طرح استیکنیگ",
        apr: "APR تخمینی",
        unlockDelay: "مدت زمان آزاد سازی",
        minMaxLimit: "حداقل/حداکثر مقدار ورود",
        minMaxAPR: "حداکثر/حداقل APR",
        availableToStake: "باقیمانده طرح",
        endDate: "زمان پایان طرح",
        autoRenew: "تمدید خودکار",
        joinedStaking: "شرکت در طرح",
        openNotificationSent: "باز شد به من اطلاع بده",
        expireTime: "اتمام مهلت عضویت",
        expirePlan: "اتمام طرح",
        existed: "دارد",
        notExisted: "ندارد",
        currentReward: "پاداش (تا امروز)",
        endSubscriptionTime: "تا پایان این دوره",
        finishedPlan: "طرح به پایان رسیده",
        View_Details: "مشاهده جزئیات",
        planDateRange: "بازه زمانی طرح",
        vipPlan: "طرح ویژه"
      }
    },
    dialogDetail: {
      View_Complete_Plan_Information:
        "در این بخش شما اطلاعات کلی مربوط به طرح خود را به طور کامل می‌توانید مشاهده کنید.",
      Plan_Information: "اطلاعات طرح",
      Plan_Timeline: "زمان بندی طرح",
      Reward_Table: "جدول پاداش",
      Invite_Friends: "دعوت از دوستان",
      contributionHistory: "تاریخچه مشارکت",
      planInfo: {
        Estimated_Active_Reward_APR: "پاداش تقریبی فعال، APR (سالانه)",
        Reward_Earned_To_Date: "پاداش به دست آمده تا امروز",
        Reward_Earned: "پاداش به دست آمده",
        Your_Contribution: "میزان مشارکت شما",
        Remaining_Days_Total_Days: "روزهای مانده / روزهای کل طرح",
        Withdrawal_Fee: "هزینه انصراف از طرح",
        Auto_Renewal_Fee: "هزینه تمدید خودکار",
        Waiting_Period_For_Asset_Release: "مدت زمان آزاد سازی دارایی",
        Waiting_Period_For_Asset_Release_After_Withdrawal:
          "مدت زمان آزاد سازی دارایی پس از انصراف",
        Plan_Join_Date: "تاریخ پیوستن به طرح",
        Withdrawal_Date: "تاریخ انصراف",
        Renewal_End_Date: "تاریخ اتمام تمدید",
        Withdraw_From_Plan: "انصراف از طرح",
        Confirm_Withdrawal_Message:
          "با انصراف از طرح، پاداش دوره جاری به شما تعلق نخواهد گرفت و ممکن است هزینه انصراف از طرح استیکینگ از شما کسر شود. توصیه می‌کنیم به منظور کسب پاداش تا پایان دوره جاری از طرح انصراف ندهید. آیا برای انصراف از طرح اطمینان دارید؟"
      },
      planSchedule: {
        Registration_Date: "تاریخ ثبت نام",
        Start_Of_Staking_Plan: "آغاز طرح استکینگ جاری شما",
        Start_Of_Staking: "آغاز طرح استکینگ",
        Daily_Profit_Distribution_Date: "تاریخ توزیع پاداش روزانه",
        Plan_End_Date: "تاریخ اتمام طرح",
        Profit_Release_Date: "تاریخ آزادسازی پاداش",
        Asset_Release_Date: "تاریخ آزادسازی دارایی",
        Enable_Auto_Renewal_Description:
          "با فعال سازی این بخش میتوانید طرح خود را مجددا تمدید کنید",
        Enable_Auto_Renewal: "فعال‌سازی تمدید خودکار",
        Disable_Auto_Renewal: "غیرفعال‌سازی تمدید خودکار",
        Plan_Renewal: "تمدید طرح",
        Auto_Renewal_Description:
          "با تمدید خودکار، دارایی شما در پایان دوره استیکینگ به دوره بعد منتقل می‌شود. توجه داشته باشید پاداش استیکینگ هر دوره به کیف پول شما واریز می‌شود و به دوره بعد منتقل نمی‌شود.",
        Auto_Renewal_Disabled_Description:
          "با غیرفعال‌سازی تمدید خودکار، پس از پایان دوره استیکینگ دارایی شما به صورت خودکار تمدید نخواهد شد و باید به صورت دستی تمدید انجام شود."
      },
      rewardTable: {
        Date: "تاریخ",
        Reward_Percentage: "درصد پاداش",
        Daily_Received_Amount: "مبلغ دریافتی روزانه"
      },
      ContributionHistory: {
        courseStart: "شروع دوره",
        status: "وضعیت"
      },
      inviteFriends: {}
    }
  },
  calculator: {
    title: "محاسبه گر پاداش استیکینگ",
    description:
      "شما میتوانید با قرار دادن مبلغ مدنظر خودتان میزان پاداش تقریبی خودتان را محاسبه کنید",
    step1: "مرحله ۱",
    step2: "میزان پاداش تقریبی در بازه زمانی های این طرح",
    aproximateReward: "پاداش تقریبی محاسبه شده",
    day: "روز",
    attentStakingBtn: "شرکت در طرح",
    participaterAmount: "میزان مشارکت",
    assetAmount: "موجودی"
  },
  features: {
    feature1: {
      title: "کسب درآمد غیرفعال",
      description:
        "با استیکینگ می‌توانید بدون نیاز به ترید یا ماینینگ، از دارایی‌های دیجیتال خود پاداش گرفته و درآمد غیرفعال داشته باشد."
    },
    feature2: {
      title: "امنیت و پایداری شبکه",
      description:
        "با قفل کردن ارزهای دیجیتال، به تأمین امنیت بلاکچین کمک می‌کنید و در تأیید تراکنش‌ها مشارکت دارید."
    },
    feature3: {
      title: "مولتی استیکینگ اکسکوینو",
      description:
        "شما قادر میباشد بعد از شرکت در یک طرح مجدد در اون طرح بارها و بارها شرکت کنید."
    },
    feature4: {
      title: "مصرف انرژی کمتر نسبت به ماینینگ",
      description:
        "برخلاف استخراج (ماینینگ) که نیاز به سخت‌افزار قدرتمند و برق زیاد دارد، استیکینگ به حداقل منابع نیاز دارد."
    },
    feature5: {
      title: "ریسک کم",
      description:
        "در استیکینگ، نیازی به پیش‌بینی لحظه‌ای قیمت‌ها ندارید و نوسانات بازار تأثیر کمتری روی کسب پاداش و درامد غیرفعال شما دارد."
    }
  },
  stakingDetailPage: {
    canCancel: "امکان انصراف از طرح",
    Registration_Deadline: "مهلت ثبت نام",
    Renewal_End_Date: "تاریخ اتمام تمدید",
    Agree_Staking_Contract_HTML:
      'من <span class="primary--text">قرارداد استیکینگ</span> را خوانده‌ام و با آن موافقم.',
    Daily: "روزانه",
    Weekly: "هفتگی",
    Monthly: "ماهانه",
    Yearly: "سالانه",
    minParticipation: "حداقل میزان مشارکت",
    assets: "موجودی",
    your_plans_step: "مراحل طرح شما",
    maxTransfer: "بیشتر از مقدار مجاز",
    minTransfer: "کمتر از مقدار مجاز",
    minAPR: "حداقل APR",
    maxAPR: "حداکثر APR",
    activeAPR: "APR فعال",
    maxPlanCapacity: "ظرفیت کل طرح",
    entryFee: "هزینه ورود به طرح",
    cancelFee: "هزینه انصراف از طرح",
    planDetails: "جزئیات طرح",
    oneDayAfterPlanCompletion: " {day} روز بعد از اتمام طرح",
    oneDayAfterWithdrawal: "{day} روز بعد از انصراف",
    subscriptionPlanTimeline: "زمانبندی طرح",
    PossibilityCanceling: "امکان انصراف از طرح"
  },
  statusPage: {
    Plan_Activated: "طرح شما فعال شد",
    View_My_Plans: "مشاهده طرح‌های من",
    Plans_List: "لیست طرح‌ها"
  },
  FAQ: {
    faq1: {
      title: " استیکینگ چیست و چگونه کار می‌کند؟",
      desc:
        "استیکینگ یعنی سپردن دارایی‌های کریپتویی به شبکه‌ای مبتنی بر الگوریتم اثبات سهام (Proof of Stake) یا تأمین نقدینگی در یک پلتفرم. با این کار، علاوه بر مشارکت در امنیت شبکه، پاداش‌هایی به صورت روزانه یا دوره‌ای دریافت می‌کنید. <br> <br>" +
        "اکسکوینو این فرایند را ساده‌سازی کرده تا بدون نیاز به دانش فنی، تنها با چند کلیک بتوانید وارد دنیای درآمد غیرفعال شوید."
    },
    faq2: {
      title: "تفاوت بین طرح پاداش ثابت و متغیر چیست؟",
      desc:
        "طرح با APR ثابت: نرخ پاداش سالیانه از پیش مشخص است و به صورت روزشمار، یکنواخت و بدون تغییر در طول دوره پرداخت می‌شود. <br><br>" +
        "طرح با APR متغیر (انعطاف‌پذیر): حداقل نرخ پاداش تضمین شده است، اما با توجه به شرایط شبکه یا بازار، ممکن است نرخ بالاتری دریافت کنید."
    },
    faq3: {
      title: " آیا می‌توانم دارایی‌ها را قبل از پایان دوره برداشت کنم؟",
      desc:
        "بله، در طرح‌های انعطاف‌پذیر، امکان برداشت سریع وجود دارد که دارایی در کیف پول اسپات قابل معامله یا برداشت است. در طرح‌های قفل‌شده، برداشت قبل از موعد ممکن است باعث کسر پاداش شود."
    },
    faq4: {
      title: "نحوه دریافت و محاسبه پاداش‌ها چگونه است؟",
      desc:
        "پاداش‌ها به صورت روزشمار محاسبه شده و معمولاً بعد از سرمایه‌گذاری یا فعال‌سازی طرح، به کیف پول انتقال می‌یابد.<br><br>" +
        "    • در طرح‌های ثابت، مبلغ بازگشت سالیانه تقسیم بر ۳۶۵ برای هر روز اعمال می‌شود.<br><br>" +
        "    • در طرح‌های متغیر، APR  بر اساس شرایط بازار روزانه تعیین شده و محاسبه می‌شود."
    },
    faq5: {
      title: "حداقل و حداکثر مبلغ سرمایه‌گذاری چقدر است؟",
      desc:
        "حداقل سپرده برای استیکینگ در اکسکوینو ممکن است محدودیت‌هایی داشته باشد و APR در سقف خاصی اعمال شود . اکسکوینو نیز حداقل و حداکثر را مشخص می‌کند تا کارایی و ارزش اقتصادی حفظ شود."
    },
    faq6: {
      title: "چه ارزهایی قابل استیک هستند؟",
      desc:
        "اکسکوینو از مجموعه‌ای از شاخص‌ترین رمز‌ارزها برای استیکینگ پشتیبانی می‌کند؛ از جمله:<br><br>" +
        "ETH، ADA، DOT، PAXG، XRP، AVAX  و چند ارز دیگر.<br><br>" +
        'فهرست ارزهای قابل استیک در حال گسترش است و می‌توانید آن را در بخش "استخرهای مشارکت" مشاهده کنید.'
    },
    faq7: {
      title:
        "چقدر می‌توانم به استیکینگ در اکسکوینو اعتماد کنم؟ چه نکاتی را باید بدانم؟",
      desc:
        "در اکسکوینو، استیکینگ با اولویت امنیت دارایی کاربران و شفافیت کامل در اطلاع‌رسانی شرایط طرح‌ها طراحی شده است. شما می‌توانید با اطمینان، در طرح‌هایی مشارکت کنید که:<br><br>" +
        "    • اطلاعات پاداش، دوره و شرایط برداشت به‌صورت شفاف و از پیش مشخص هستند<br><br>" +
        "    • دارایی‌ها در فضای کاملاً محافظت‌شده و کنترل‌شده نگهداری می‌شوند<br><br>" +
        "    • تیم اکسکوینو تلاش می‌کند همواره ریسک‌های احتمالی مانند نوسانات بازار یا قفل‌شدن دارایی در برخی طرح‌ها را به‌صورت واضح توضیح دهد، تا شما با اطمینان و آگاهی کامل تصمیم بگیرید<br><br>" +
        "پیشنهاد می‌کنیم پیش از انتخاب هر طرح، شرایط آن را بررسی کرده و در صورت نیاز با تیم پشتیبانی مشورت کنید. ما همراه شما هستیم تا بهترین انتخاب را داشته باشید."
    }
  }
};
